import { createFileRoute } from '@tanstack/react-router'
import { PersonalDataPage } from '@/pages/PersonalDataPage'

const PersonalData = () => {
  return <PersonalDataPage />
}

export const Route = createFileRoute('/personal-data')({
  component: PersonalData,
})
